import * as monacoEditor from 'monaco-editor';
import { useCallback } from 'react';

import { useDerivedEditorValue } from 'src/app/graph/explorerPage/hooks/useDerivedEditorValue';
import { useDebouncedValue } from 'src/hooks/useDebouncedValue';
import { tolerantParseSchema } from 'src/lib/chevrotain/tolerantParseSchema';

export const useDebouncedDocumentNode = (
  editor: monacoEditor.editor.IStandaloneCodeEditor,
) => {
  const { documentNode } = useDerivedEditorValue({
    editor,
    getValue: useCallback(
      (editorValue: string) =>
        tolerantParseSchema(monacoEditor.editor.createModel(editorValue)),
      [],
    ),
    withPosition: false,
  });

  return useDebouncedValue(documentNode, 1000);
};
